<template>
  <v-container fluid id="dump-report" class="pa-0 pa-sm-3">
    <!-- Image Modal -->
    <v-dialog v-model="imageDialog" max-width="800px">
      <v-card>
        <v-card-title class="pa-2">
          <span class="headline">Dump Ticket Image</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="imageDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-img
            v-if="selectedImage"
            :src="selectedImage"
            contain
            max-height="600"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row wrap justify="center">
      <v-col xs="9" class="headline pb-0"
        >Truck Requests - Report<br /><span class="caption"
          >Showing most recent 150 dump tickets.</span
        ></v-col
      >
      <!-- Client Filter -->
      <v-col cols="12" xs="12" class="pb-0">
        <v-select
          v-model="selectedClientFilter"
          :items="clientFilterOptions"
          item-text="text"
          item-value="value"
          label="Filter by Client"
          outlined
          dense
          hide-details
          class="mb-3"
          style="max-width: 200px;"
        ></v-select>
      </v-col>
      <!--  TRUCK REQUESTS -->
      <v-col cols="12" xs="12">
        <v-card>
          <!-- <v-tabs>
            <v-tab
              @click="
                orderType = 'dumpTickets';
                page = 1;
              "
            >
              Closed
            </v-tab>
          </v-tabs> -->
          <v-divider></v-divider>
          <v-data-table
            :items="filteredDumpTickets"
            :headers="headers"
            sort-by="requestType"
            :items-per-page="150"
            :hide-default-footer="true"
            dense
          >
            <template v-slot:item.requestDate="{ item }">
              {{ item.requestDate | moment("MM/DD/YYYY") }}
            </template>
            <template v-slot:item.jobSite.street="{ item }">
              {{ item.jobSite.street }}<br />
              <span class="caption">
                {{ item.jobSite.street2 }} ({{ item.jobSite.jobId }})</span
              >
            </template>
            <template v-slot:item.yards="{ item }">
              {{ item.yards }}
            </template>
            <template v-slot:item.loadWeight="{ item }">
              {{ item.loadWeight }}
              <span class="caption">{{ item.loadWeightType }}</span>
            </template>
            <template v-slot:item.materialTypeBreakdown="{ item }">
              <span
                class="caption"
                v-for="(m, ix) of item.materialTypeBreakdown"
                :key="ix"
              >
                {{ m.percent }}% {{ m.material }}
              </span>
            </template>
            <template v-slot:item.dumpTicketImage="{ item }">
              <v-btn
                icon
                small
                v-for="image of item.dumpTicketImage"
                :key="image"
                @click="openImageModal(image)"
              >
                <v-icon small>image</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.arrivalTime="{ item }">
              <span v-if="item.arrivalTime">{{
                item.arrivalTime.toDate() | moment("h:mma")
              }}</span>
              <span v-else class="grey--text">-</span>
            </template>
            <template v-slot:item.finishTime="{ item }">
              <div>
                <span v-if="item.finishTime">{{
                  item.finishTime.toDate() | moment("h:mma")
                }}</span>
                <span v-else class="grey--text">-</span>
                
                <!-- Duration calculation -->
                <div v-if="item.arrivalTime && item.finishTime" class="caption grey--text">
                  {{ getDurationInMinutes(item.arrivalTime, item.finishTime) }}m
                  <v-icon 
                    v-if="isDurationSuspicious(item.arrivalTime, item.finishTime)"
                    small
                    color="warning"
                    class="ml-1"
                  >
                    warning
                  </v-icon>
                </div>
              </div>
            </template>
            <template v-slot:item.request="{ item }">
              <a
                :href="`/truck-requests/manage/orders/${item.requestId}`"
                target="_blank"
                >view</a
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { sortBy } from "lodash";
export default {
  data() {
    return {
      orderType: "dumpTickets",
      dialog: false,
      imageDialog: false,
      selectedImage: null,
      selectedClientFilter: "all",
      clientFilterOptions: [
        { text: "All Clients", value: "all" },
        { text: "ALBA Only", value: "ALBA" },
        { text: "External Only", value: "External" },
      ],
      dumpTickets: [],
      headers: [
        { text: "Request Date", value: "requestDate", width: 110 },
        { text: "Job Site", value: "jobSite.street" },
        { text: "Yrds", value: "yards", width: "60" },
        { text: "Driver", value: "driverName" },
        { text: "Location", value: "dumpSite" },
        { text: "Load Weight", value: "loadWeight" },
        { text: "Arrival", value: "arrivalTime", width: "80" },
        { text: "Finish", value: "finishTime", width: "80" },
        { text: "LEED", value: "materialTypeBreakdown", width: "300" },
        { text: "Client", value: "client" },
        { text: "Ticket", value: "ticketNumber" },
        { text: "Image", value: "dumpTicketImage", width: "100" },
        { text: "Request", value: "request", width: "100", align: "center" },
      ],
    };
  },
  computed: {
    filteredDumpTickets() {
      if (this.selectedClientFilter === "all") {
        return this.dumpTickets;
      }
      return this.dumpTickets.filter(
        (ticket) => ticket.client === this.selectedClientFilter
      );
    },
  },
  async created() {
    const fbRes = await fb.db
      .collection("truckRequests")
      .where("status", "==", "closed")
      .orderBy("orderDate", "desc")
      .limit(150)
      .get();
    var closedRequests = [];
    fbRes.forEach(function(doc) {
      closedRequests.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    // Create a map to track ticket numbers across all orders (matching backend logic)
    const ticketMap = new Map();

    // First pass: Populate the ticketMap with ticketNumbers
    closedRequests.forEach((tr) => {
      if (tr.dumpTickets) {
        const tickets = Object.values(tr.dumpTickets);
        tickets.forEach((t) => {
          if (ticketMap.has(t.ticketNumber)) {
            // If ticket number exists, append the ticket to the existing array
            ticketMap.get(t.ticketNumber).push(t);
          } else {
            // If ticket number does not exist, add it to the map
            ticketMap.set(t.ticketNumber, [t]);
          }
        });
      }
    });

    const dumpTickets = [];
    closedRequests.forEach((tr) => {
      if (tr.dumpTickets) {
        const tickets = Object.values(tr.dumpTickets);
        tickets.forEach((t) => {
          // Check if this ticket number has duplicates across orders
          if (ticketMap.get(t.ticketNumber).length > 1) {
            // If there are multiple tickets with the same number, clear loadWeight for all but one
            const firstTicket = ticketMap.get(t.ticketNumber)[0];
            if (t !== firstTicket) {
              t.loadWeight = ""; // Clear the loadWeight for duplicates
            }
          }
        });

        dumpTickets.push(
          tickets.map((t) => {
            // Format load weight like backend (lines 496-500)
            let formattedLoadWeight = "";
            if (t.loadWeight) {
              if (t.loadWeight > 100) {
                formattedLoadWeight = `${t.loadWeight}`;
              } else {
                formattedLoadWeight = `${t.loadWeight * 2000}`;
              }
            }

            return {
              ...t,
              loadWeight: formattedLoadWeight, // Use formatted load weight
              materialTypeBreakdown: tr.materialTypeBreakdown,
              jobSite: tr.jobSite,
              requestId: tr.orderNumber,
              requestDate: tr.requestDate, // Use requestDate consistently
              driverName: `${tr.scheduledDriver.firstName} ${tr.scheduledDriver.lastName}`,
              client: tr.jobSite.jobId.startsWith("TR") ? "External" : "ALBA",
              arrivalTime: tr.arrivalTime, // Add arrival time from truck request
              finishTime: tr.finishTime, // Add finish time from truck request
            };
          })
        );
      }
    });
    this.dumpTickets = sortBy(dumpTickets.flat(), "requestDate").reverse();
  },
  methods: {
    openImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.imageDialog = true;
    },
    getDurationInMinutes(arrivalTime, finishTime) {
      if (!arrivalTime || !finishTime) return 0;
      const arrival = arrivalTime.toDate();
      const finish = finishTime.toDate();
      const diffInMs = finish - arrival;
      const diffInMinutes = Math.round(diffInMs / (1000 * 60));
      return Math.max(0, diffInMinutes); // Ensure non-negative
    },
    isDurationSuspicious(arrivalTime, finishTime) {
      const duration = this.getDurationInMinutes(arrivalTime, finishTime);
      // Flag as suspicious if 0 minutes or over 4 hours (240 minutes)
      return duration === 0 || duration > 240;
    },
  },
};
</script>
<style>
#dump-report .v-data-table td {
  padding: 0 8px !important;
}
</style>
